import React, { useEffect, useState } from "react";
import Pagination from '../../../../components/Pagination';
import Loader from '../../../../components/Loader';
import EditableTable from "./Table";
import Modal from "../../../../components/Modal"
import ChangeLog from "../../../../components/ChangeLog";
import api from "../../../../auth/api";
import { alertSuccess, alertError } from "../../../../components/Alert";
import Add from "./Add";
import { fetchCountryList } from "@/slices/LocationSlice/countrySlice";
import { useSelector, useDispatch } from "react-redux";
import EditGiftCard from "./EditGiftCard";

export default function GiftCard() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [changeLogData, setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['title', 'detail', 'status', 'agency', 'brand', 'value', 'country'];
  const [addDis, setAddDis] = useState(false);
  const [agencyList, setAgencyList] = useState([]);
  const { countryList, status } = useSelector((state) => state.countryList);
  const [brandList, setBrandList] = useState([])

  useEffect(() => {
    fetchData();
    getAgencyList();
    getBrandList();
  }, []);


  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchCountryList());
    }
  }, [dispatch, status])

  const fetchData = async () => {
    try {
      const response = await api.get("/redeem/panel/gift/card");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const getAgencyList = async () => {
    try {
      const response = await api.get("/redeem/panel/agency");
      setAgencyList(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const getBrandList = async () => {
    try {
      const response = await api.get("/redeem/panel/brands");
      setBrandList(response.data.result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const handleEdit = (rowId) => {
    const rowData = data.find((item) => item.id === rowId);
    // setEditRowId(rowId);
    setEditedData(rowData);
    setIsModalOpen(true);
  };

  // const handleSave = async () => {
  //   try {

  //     const agencyId = agencyList?.filter(f => f.agencyName === editedData?.agency)[0].id;
  //     const brandId = brandList?.result?.filter(f => f.name === editedData?.brand)[0].id;
  //     const countryId = countryList?.result?.filter(f => f.title === editedData?.country)[0].id;

  //     const finalData = {
  //       id: editedData.id,
  //       title: editedData.title,
  //       detail: editedData.detail,
  //       points: editedData.points,
  //       stock: editedData.stock,
  //       status: editedData.status,
  //       value: editedData.value,
  //       productId: editedData.productId,
  //       agency: agencyId,
  //       country: countryId,
  //       brand: brandId
  //     }

  //     await api.patch(`/redeem/panel/gift/card`, finalData);
  //     alertSuccess("Data updated successfully");
  //     setEditRowId(null);
  //     fetchData();
  //   } catch (error) {
  //     alertError(error?.response?.data?.errors)
  //     console.error("Error updating data:", error);
  //   }

  // };


  const handleSave = async (updatedData) => {
  try {

    const finalData = {
      id: updatedData.id,
      title: updatedData.title,
      detail: updatedData.detail,
      stock: updatedData.stock,
      status: updatedData.status,
      value: updatedData.value,
      agency: updatedData.agency,   // ✅ already ID
      brand: updatedData.brand,     // ✅ already ID
      country: updatedData.country  // ✅ already ID
    };

    await api.patch(`/redeem/panel/gift/card`, finalData);

    alertSuccess("Data Updated successfully");
    setIsModalOpen(false);
    fetchData();

  } catch (error) {
     alertError(error?.response?.data?.errors);
  }
};


  
  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true);
  };



  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = async (row, file) => {
    try {
      const formData = new FormData();
      formData.append("productImage", file);
      formData.append("id", row.id); // if ID is required by backend
      const response = await api.patch(`/redeem/panel/gift/card`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      alertSuccess("Image uploaded successfully");
      fetchData(); // Refresh table
    } catch (error) {
      console.error("Image upload failed:", error);
      alertError(error?.response?.data?.errors || "Upload failed");
    }
  };




  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
        agencyList={agencyList}
        countryList={countryList?.result}
        brandList={brandList}
      />

      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Gift Card
        </button>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />
      <Modal isOpen={addDis} onClose={() => setAddDis(false)} title="Add Gift Card" content={<Add onSuccess={fetchData} agencyList={agencyList} countryList={countryList?.result} brandList={brandList} />} />
    
     <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Edit Gift Card"
        content={
          <EditGiftCard
            initialData={editedData}
            editableFields={editableFields}
            handleSave={handleSave}
            agencyList={agencyList}
            countryList={countryList?.result}
            brandList={brandList}
          />
        }
      />
    </div>
  );
}
